<template>
  <div class="dish-container" v-if="itemListNum">
    <div class="dish-header">
      <p>{{$t('Gattaran_0509_PLgH_VDtS'/**top 10 Dishes*/)}}</p>
      <p>{{$t('Gattaran_V1__ccGl'/**过去30天*/)}}</p>
    </div>
    <div v-for="(item, index) in contentList" :key="index" class="dish-content">
      <div class="dish-title">
        <div class="dish-rank">
          <div class="rank-special" v-if="getSpecialRnk(index+1)">
            <img :src="getSpecialRnk(index+1)"/>
          </div>
          <div v-else class="rank-normal"> {{index+1}}</div>
        </div>
        <div class="dish-name">{{item.itemName}}</div>
      </div>
      <div class="dish-sales">
        <p class="dish-sales-volumn">{{item.salesVolume}}</p>
        <p class="dish-sales-gmv">{{item.salesGmvRadio}}%</p>
      </div>
    </div>
    <div class="item-view" @click="toogleCollapse">
      <p>{{toggleText()}}</p>
      <i class="crm--chevron_down" :class="{'transform-icon': collapse}"></i>
    </div>
  </div>
</template>

<script>
import { slice } from 'lodash'
export default {
  name: 'TopItems',
  components: {
  },
  data () {
    return {
      collapse: true,
    }
  },
  props: {
    itemData: {
      type: Array,
      default: () => ([])
    },
  },
  computed: {
    itemListNum() {
      return this.itemData.length
    },
    contentList() {
      return this.collapse ? slice(this.itemData, 0, 5) : this.itemData
    }
  },
  methods: {
    getSpecialRnk(index) {
      const specialImgList = {
        1: require('../../../assets/img/top1.png'),
        2: require('../../../assets/img/top2.png'),
        3: require('../../../assets/img/top3.png'),
      }
      return specialImgList[index]
    },
    toggleText () {
      return this.collapse ? this.gettext('查看更多') : this.gettext('点击收起')
    },
    toogleCollapse() {
      this.collapse = !this.collapse
    },
  },
  created() {
  }
}
</script>

<style lang="scss" scped>
@import '@/common/style/mixin.scss';
.dish-container{
  padding-top: 40px;
  margin-bottom: -24px;
  .dish-header{
    display: flex;
    height: 60px;
    justify-content: space-between;
    @include border-bottom-1px(#ebebeb, solid);
    p{
      font-family: DiDiSans-Pro-Regular;
      font-size: 20px;
      line-height: 60px;
      color: #999999;
      font-weight: 400;
    }
  }
  .dish-content{
    height: 120px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 24px;
    @include border-bottom-1px(#ebebeb, solid);
  }
  .dish-title{
    display: flex;
    .dish-rank{
      width: 48px;
      height: 48px;
      display: flex;
      .rank-normal{
        width: 36px;
        height: 36px;
        background: #F5F5F5;
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: DiDiSans-Pro-Medium;
        font-size: 20px;
        color: #666666;
        text-align: center;
        line-height: 28px;
        font-weight: 500;
        margin-top: 8px
      }
      .rank-special{
        justify-content: center;
        align-items: center;
        img{
          width: 48px;
          height: 48px;
        }
      }
    }
    .dish-name{
      height: 48px;
      line-height: 48px;
      font-family: DiDiSans-Pro-Regular;
      font-size: 28px;
      color: #333333;
      font-weight: 400;
      margin-left: 12px;
    }

  }
  .dish-sales{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .dish-sales-volumn{
      font-family: DiDiSans-Pro-Medium;
      font-size: 28px;
      color: #333333;
      font-weight: 500;
      margin-bottom: 8px;
    }
    .dish-sales-gmv{
      font-family: DiDiSans-Pro-Regular;
      font-size: 24px;
      color: #999999;
      font-weight: 400;
    }
  }
  .item-view{
    height: 65px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: DiDiSans-Pro-Regular;
    font-size: 24px;
    color: #666666;
    font-weight: 400;
    .transform-icon{
      transform: rotate(180deg);
    }
    .crm--chevron_down{
      font-size: 24px;
      width: 24px;
      height: 24px;
      margin-left: 16px;
    }

  }
}
</style>
